import { render } from "./complete-the-look.vue?vue&type=template&id=783f5be8"
import script from "./complete-the-look.vue?vue&type=script&lang=js"
export * from "./complete-the-look.vue?vue&type=script&lang=js"

import "./complete-the-look.vue?vue&type=style&index=0&id=783f5be8&lang=scss"

import exportComponent from "/Users/connoringold/Documents/projects/bao/toteme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__